import CloseIcon from '@mui/icons-material/Close';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import {
  Box,
  DialogContent,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { isEmpty } from 'lodash-es';
import {
  WsButton,
  WsColors,
  WsDialog,
  WsDialogSize,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

interface IShareCandidateConfirmation {
  onClose: () => void;
  isEvalNeeded: boolean;
  invalidEmails?: {
    name: string;
    email: string;
  }[];
}

const ShareCandidateConfirmation = ({
  onClose,
  isEvalNeeded,
  invalidEmails,
}: IShareCandidateConfirmation) => (
  <WsDialog size={WsDialogSize.SMALL} openDialog={true} onClose={onClose}>
    <Box sx={{ width: '100%' }}>
      <CloseIcon
        onClick={onClose}
        sx={{ float: 'right', mr: 2, fontSize: '23px', mt: 1.8, cursor: 'pointer' }}
      />
    </Box>
    <DialogContent>
      <Grid container item xs={12} justifyContent="center" alignItems="center">
        <MarkEmailReadIcon sx={{ color: WsColors.TheBlues500, fontSize: '66px' }} />
      </Grid>
      <Grid container item xs={12} justifyContent="center" alignItems="center">
        <WsTypography variant={WsTypoVariants.SUB_TITLE} bold>
          Email sent
        </WsTypography>
      </Grid>
      <Grid container item xs={12} justifyContent="center" alignItems="center">
        <WsTypography>
          {isEvalNeeded ? 'View candidate and evaluate' : 'View Candidate'}
        </WsTypography>
      </Grid>

      {!isEmpty(invalidEmails) && (
        <Grid container item xs={12} mt={1}>
          <WsTypography bold>Invalid Emails Detected</WsTypography>
          <TableContainer component={Paper} sx={{ mt: 0.5 }}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invalidEmails?.map((list, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {list.name}
                    </TableCell>
                    <TableCell>{list.email}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}
      <Grid container item xs={12} justifyContent="center" alignItems="center" mt={5}>
        <WsButton onClick={onClose}>Okay</WsButton>
      </Grid>
    </DialogContent>
  </WsDialog>
);

export default ShareCandidateConfirmation;
